import { FC, ReactNode } from "react";

interface IMainContainer {
  children: ReactNode;
}

export const MainContainer: FC<IMainContainer> = ({ children }) => {
  return (
    <>
      {/* <div className="flex">
        <Sidebar /> */}

      <section className="py-6 px-4 md:pb-6 pb-20 w-full max-w-4xl mx-auto">
        {children}
      </section>
      {/* </div> */}

      {/* <TermsFooter /> */}
    </>
  );
};
